export enum WindowGrouping {
  Single = 'single',
  Double = 'double',
  Triple = 'triple',
  Quadruple = 'quadruple',
}
